export default ({ get, checkStatus, toJSON }) => ({
  spotlight: (id) =>
    get(`universe/v1/home_page_spotlight/search?spotlight_ids=[${id}]`)
      .then(checkStatus)
      .then(toJSON),
});
